import { api } from "./api";
import * as endpoints from "../data/links/endpoints";

export async function getWorkoutByTypeStats({ periodId, signal }) {
  return api
    .get(endpoints.GET_WORKOUT_BY_TYPE_STATS + periodId, { signal })
    .then((res) => res.data.stats)
    .catch((error) => error.response);
}

export async function getWorkoutByCategoryStats({ periodId, signal }) {
  return api
    .get(endpoints.GET_WORKOUT_BY_CATEGORY_STATS + periodId, { signal })
    .then((res) => res.data.stats)
    .catch((error) => error.response);
}

export async function getWorkoutPerformance({ type, dateRange, signal }) {
  return api
    .get(endpoints.GET_WORKOUT_PERFORMANCE + type + "/" + dateRange, {
      signal,
    })
    .then((res) => res.data.performance)
    .catch((error) => error.response);
}

export async function getAthleteVersusStats({ athleteId, signal }) {
  return api
    .get(endpoints.GET_ATHLETE_VERSUS_STATS + athleteId, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getChallengeStatistics({ signal }) {
  return api
    .get(endpoints.GET_ATHLETE_CHALLENGE_STATISTICS, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}
